import Reveal from './Reveal';

const SECONDARY = [
  { tag: '起底', title: '带货主播「原厂货」疑云：从生产记录到第三方抽检的多方比对', time: '更新于 21:40', hot: 982 },
  { tag: '内幕', title: '综艺「剧本内定」争议再升温，现场观众证词被逐条整理归档', time: '更新于 20:15', hot: 876 },
  { tag: '扒皮', title: '头部 MCN 高额解约条款外流，业内直呼「同款模板满天飞」', time: '更新于 17:08', hot: 590 },
];

export default function LeadHero() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-16">
      {/* 上疏：今日头版大标题 */}
      <Reveal>
        <div className="grid gap-8 lg:grid-cols-12 lg:gap-10">
          {/* 左侧头版主打文案 */}
          <div className="lg:col-span-7 xl:col-span-7">
            <div className="flex flex-wrap items-center gap-2">
              <span className="rounded-full bg-[#c83424] px-3 py-1 text-[11px] font-semibold tracking-wide text-white">
                今日头版 · 实锤
              </span>
              <span className="flex items-center gap-1 rounded-full bg-[#f0e8d8] px-3 py-1 text-[11px] font-medium text-[#6b5f51]">
                <i className="ri-live-line text-[#c83424]"></i>线索复核第 3 轮
              </span>
            </div>

            <h1 className="font-display mt-6 text-4xl font-black leading-[1.18] tracking-tight text-[#262019] md:text-[56px] md:leading-[1.12]">
              同一批次两套说法，
              <br />
              直播「原厂货」到底是谁在说谎？
            </h1>

            <p className="mt-6 max-w-2xl text-[15px] leading-8 text-[#5d5245]">
              一条被反复修改的生产记录，两份互相矛盾的检验说明，外加三段时间戳对不上的售后口径——我们把散落在各个平台的原帖、单据截图与旁证逐条编号，拼出一张完整的时间线。带货「以次充好」的争议，从来不是只靠一条视频就能说清的事。
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-3">
              <button className="flex items-center gap-2 rounded-md bg-[#262019] px-5 py-3 text-sm font-semibold text-[#f5efe3] hover:bg-[#3a3129]">
                进入专题时间线 <i className="ri-arrow-right-line"></i>
              </button>
              <button className="flex items-center gap-2 rounded-md border border-[#d0c2aa] bg-white px-5 py-3 text-sm font-semibold text-[#262019] hover:border-[#c83424] hover:text-[#c83424]">
                <i className="ri-share-forward-line"></i> 转发线索让更多人看到
              </button>
            </div>

            <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-2 border-t border-[#e0d6c6] pt-5 text-xs text-[#8a7a67]">
              <span className="flex items-center gap-1.5">
                <i className="ri-time-line text-[#c83424]"></i>信源编号 S-2034~2041
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-verified-badge-line text-[#c83424]"></i>证据比对 6 / 6 项通过
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-eye-line"></i>围观 9.8k
              </span>
            </div>
          </div>

          {/* 右侧封面视觉陪衬 */}
          <div className="lg:col-span-5">
            <div className="relative h-72 w-full overflow-hidden rounded-lg md:h-[420px]">
              <img
                src="https://readdy.ai/api/search-image?query=editorial%20investigative%20collage%20with%20newspaper%20clippings%2C%20worn%20paper%20documents%2C%20red%20proofreading%20stamp%20marks%2C%20typewriter%20prints%20and%20aged%20receipts%20overlaid%2C%20warm%20cream%20background%2C%20muted%20ink%20red%20and%20charcoal%20tones%2C%20documentary%20grain%2C%20textured%20analog%20layout&width=900&height=720&seq=lead-cover-2026-x1&orientation=portrait"
                alt="直播原厂货证据比对封面拼贴"
                className="h-full w-full rounded-lg object-cover object-top"
              />
              <div className="absolute inset-0 rounded-lg bg-gradient-to-t from-[#1c140c]/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between rounded-md bg-white/90 px-3 py-2 text-xs font-semibold text-[#262019] backdrop-blur">
                <span className="flex items-center gap-1.5">
                  <i className="ri-award-line text-[#c83424]"></i>证据包 8 份 · 已盖章核对
                </span>
                <span className="text-[#c83424]">点击展开 <i className="ri-arrow-down-s-line"></i></span>
              </div>
            </div>
          </div>
        </div>
      </Reveal>

      {/* 下密：三则次稿小卡 */}
      <Reveal delay={120}>
        <div className="mt-10 grid gap-4 border-t-2 border-[#262019] pt-6 sm:grid-cols-3">
          {SECONDARY.map((s) => (
            <a
              key={s.title}
              href="#rexian"
              className="group block cursor-pointer rounded-lg bg-white p-4 ring-1 ring-[#e6dbc9] transition hover:-translate-y-1"
            >
              <div className="flex items-center justify-between">
                <span className="rounded bg-[#f0e8d8] px-2 py-0.5 text-[11px] font-semibold text-[#a9281c]">{s.tag}</span>
                <span className="flex items-center gap-1 text-[11px] text-[#b3a58f]">
                  <i className="ri-fire-fill text-[#e8603c]"></i>{s.hot}
                </span>
              </div>
              <p className="mt-3 text-sm font-medium leading-6 text-[#332c24] group-hover:text-[#c83424]">{s.title}</p>
              <p className="mt-3 flex items-center gap-1 text-[11px] text-[#9a8a75]">
                <i className="ri-refresh-line"></i>{s.time}
              </p>
            </a>
          ))}
        </div>
      </Reveal>
    </section>
  );
}